<template>
<!-- 项目内头部 -->
    <div class="header-container header-bg" :style="headerBg">
        <div class="menu-container clearfix">
            <div class="logo">
                <router-link to="/projectsystemlist" title="项目子系统列表">
                    <!-- <img src="@/assets/zhongyi/hy-logo2.png" alt=""> -->
                    <img :src="user.company_logo ? user.company_logo : ''" alt="">
                </router-link>
            </div>
            <!-- 折叠按钮 -->
            <div class="collapse-btn" @click="collapseChage">
                <i :class="collapse? 'iconfont icon-menu-fold' : 'iconfont icon-menu-unfold'"></i>
                <el-tooltip class="item" effect="light" content="刷新" placement="right">
                    <i class="el-icon-refresh" @click="refresh" style="cursor: pointer;margin-left:15px;"></i>
                </el-tooltip>
            </div>
            <div style="overflow:hidden;">
                <!-- <router-link to="/projectlist" class="to-project"><i class="iconfont icon-liebiao" style="display:none;margin-right: 5px;vertical-align: middle;font-size: 12px;"></i>项目列表</router-link> -->
                <v-breadcrumb></v-breadcrumb>
                <!-- 切换主题色 -->
                <el-color-picker class="right-menu changeBg" size="small" show-alpha v-model="color1" @change="handleChangeColor"></el-color-picker>
                <!-- 导航栏右侧 -->
                <el-dropdown class="right-menu" @command="handleLangCommand">
                    <div class="el-dropdown-link">
                        {{$t('lang')}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cn">
                            中文
                        </el-dropdown-item>
                        <el-dropdown-item command="en">
                            English
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown class="right-menu" @command="handleLogoutCommand">
                    <div class="el-dropdown-link">
                        <i v-if="user.avatar === ''|| user.avatar === undefined" class="el-icon-user-solid"></i>
                        <img v-else :src="user.avatar" alt="" class="avatar" style="padding-left: 8px;">
                        {{user.username}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item command="userCenter">
                            {{$t('header.userCenter')}}
                        </el-dropdown-item> -->
                        <el-dropdown-item command="changepassword">
                            {{$t('menu.headchangePassword')}}
                        </el-dropdown-item>
                        <!-- <el-dropdown-item command="admin" v-if="user.Usertype === 1">
                            {{$t('menu.admin')}} 
                        </el-dropdown-item> -->
                        <el-dropdown-item command="logout">
                            {{$t('header.logout')}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div class="right-menu" @click="handleMessage">
                    <el-badge :value="unReadCount" :hidden="unReadCount===0" :max="99" class="item">
                        <i class="el-icon-bell"></i>
                    </el-badge>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import bus from "@/utils/bus";
import { mapGetters } from "vuex";
import Storage from '@/utils/storage'
import Service from '@/api/Service'
import vBreadcrumb from "./breadcrumb";
import LOGO from '@/assets/logo.jpg'

// require("./header.css");
export default {
    name: "headermenu",
    inject: ["reload"],
    data() {
        return {
            collapse: false,
            color1: 'rgb(41, 61, 110)',
            headerBg: '',
            unReadCount: 0,
            LOGO: LOGO
        };
    },
    components: { vBreadcrumb },
    computed: {
        ...mapGetters(["user"])
    },
    created() {
        // 获取用户信息
        let headerBg = Storage.get("headerBg") || this.color1;
        let val = headerBg.headerBg || headerBg;
        this.headerBg =  "background-color:"+ val;
        this.color1 = val;

        setTimeout(() => {
            this.getNotice();
        }, 1000);
    },
    mounted() {
        // 窗口响应式
        if (document.body.clientWidth < 900) {
            this.collapseChage();
        }
        window.onresize = () => {
            if(window.innerWidth<900 && !this.collapse) {
                this.collapseChage();
            } 
            if(window.innerWidth>900 && this.collapse) {
                this.collapseChage();
            }
            
        }
    },
    methods: {
        handleLangCommand(command) {
            this.$i18n.locale = command;
            Storage.set("lang", {lang:command});
        },
        handleLogoutCommand(command) {
            switch (command) {
                case "logout":
                    this.handleLogout();
                    break;
                case "userCenter":
                    break;
                case "admin":
                    this.$router.push('/admin');
                    break;
                case "changepassword":
                    this.$router.push('/changepassword');
                    break;
                default:
                    break;
            }
        },
        refresh() {
            location.reload();
        },
        // 退出登录
        handleLogout() {
            this.$store.dispatch("LogOut").then(res=> {
                // this.$router.push("/login");
                location.href = '/login'
            })
        },
        // 
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit("collapse", this.collapse);
        },
        handleChangeColor(val) {
            this.headerBg = "background-color:"+ val;
            Storage.set("headerBg", {headerBg:val});
        },
        handleMessage() {
            this.unReadCount = 0;
            this.$router.push("/message");
        },
        async getNotice() {
            let data = await Service.getNoticeUnReadList();
            if(data){
                let list = data.list == null ? [] : data.list;
                // this.tableData = list;
                this.unReadCount = data.total;
            }
        }
    },
};
</script>

<style scoped lang="less">
.header-container {
    flex: 0 0 auto;
    background-color: @header-bgcolor;
}
.menu-container .right-menu .svg-icon {
    fill: #fff !important;
}
.menu-container .right-menu:hover {
    cursor: pointer;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 60px;
    color: #fff;
    height: 60px;
}
.collapse-btn i {
    font-size: 22px;
}
.to-project{
    display: inline-block;
    vertical-align: middle;
    height: 60px;
    line-height: 60px;
    text-decoration: none;
    font-size: 14px;
    color: #fff;
    margin-right: 20px;
    &:hover{
        cursor: pointer;
        color: @primary-color;
    }
}
</style>

